var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.52 27.511c-3.505.858-5.548 1.358-7.047 3.49-.32-.963-.881-3.77 0-5.535.641-1.283 2.244-2.406 4.809-3.288 2.083-.722 4.728-1.284 7.453-1.685l.962-.08-.962-.24c-4.408-.883-7.373-1.846-10.419-4.332-1.362-1.204-2.003-3.129-1.602-4.894.24-1.443 1.362-3.93 5.85-5.213 1.496-.48 2.859-.825 4.087-1.136.417-.105.818-.207 1.203-.308l.012-.004c3.76-.88 6.16-1.443 7.361-3.286 0 .963-.08 3.048-1.603 5.134-2.003 2.807-5.77 4.492-11.14 5.214l-.96.08.88.24c4.408.883 7.374 1.926 10.42 4.412 1.361 1.123 2.083 3.048 1.682 4.893-.32 1.364-1.443 3.85-5.93 5.214-1.924.562-3.447.963-4.89 1.284l-.166.041zM22.5 14.156c-1.36-.962-2.884-1.765-5.128-2.567 3.046-.882 5.37-2.326 6.892-4.17.16 1.844.08 4.651-1.763 6.737z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuper);
export default __webpack_public_path__ + "static/media/SUPER.4e52a14097efa78b725cdbe509cee8c6.svg";
export { ForwardRef as ReactComponent };